import * as React from 'react';
import { connect } from 'react-redux';
import { flatMap } from 'lodash';

import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformance, IPackage } from '../../custom/classes/production';
import ListPackageView from '../../views/library/list-package.view';
import { IPackageListingAppSettings } from '../../custom/classes/package-listing-settings';
import { toggleMiniCart, selectPackage, removeItemFromCart } from '../../redux-state/actions/package-listing.actions';
import { getAllPackagePerformances } from '../../helpers/performances-selectors';

interface IListPackageExternalProps {
    package: IPackage;
}

interface StateToProps {
    text: IPackageListingAppText;
    settings: IPackageListingAppSettings;
    useUnseatedReserve: boolean;
    selectedPackage: boolean;
    filterFunction: (option) => any;
    numberOfPackagesInList: number;
    defaultPackageImageUrl: string;
    matchesCurrentRenewalPackage: boolean;
}

interface DispatchToProps {
    selectPackage: (pkg: IPackage, unseated: boolean) => void;
    removeFromCart: (itemId: number) => void;

}

interface ListPackageViewState {
    showPerformances: boolean;
    availabilityLevelDescription: string;
    availabilityLevelCssClass: string;
}

interface ViewProps {
    toggleShowPerformances: () => void;
    packagePerformances: Array<IPerformance>;
}

export type ListPackageProps = IListPackageExternalProps & StateToProps & DispatchToProps;;

export type CombinedPackageViewProps = ListPackageProps & ListPackageViewState & ViewProps;

export class ListPackageBase extends React.Component<ListPackageProps, ListPackageViewState, any> {

    constructor(props: ListPackageProps) {
        super(props);
        this.state = {
            showPerformances: false,
            availabilityLevelDescription: null,
            availabilityLevelCssClass: null
        };
    }
    render() {
        const allPerf = getAllPackagePerformances(this.props.package);
        const filteredPerformances = allPerf.filter(this.props.filterFunction);
        const showPackage = filteredPerformances.length > 0;

        return (
            <ListPackageView
                {...this.props}
                {...this.state}
                showPackage={showPackage}
                selectedPackageId={null}
                packagePerformances={allPerf}
                toggleShowPerformances={this._toggleShowPerformances.bind(this)}
                showSelectButton={true}
                disableSeriesButtons={false}
                disableAllSeries={null}
                reachedMaxQuantity={false}
                alternatePackageSelected={false}
                removeItemFromCart={null }
            />
        )

    }

    _toggleShowPerformances = () => {
        this.setState(
            { showPerformances: !(this.state.showPerformances) }
        );
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListPackageExternalProps): StateToProps {
    return {
        text: state.packageListingText,
        settings: state.packageListingSettings,
        useUnseatedReserve: state.packageListingSettings.useUnseatedReservation,
        selectedPackage: state.packageListing.cartItems.length > 0 && state.packageListing.subPackagesInCart.keys().next().value == ownProps.package.id,
        filterFunction: state.packageListing.filterFunction,
        numberOfPackagesInList: state.packageListing.packages.length,
        defaultPackageImageUrl: state.packageListingSettings.defaultPackageImageUrl,
        matchesCurrentRenewalPackage: false 
    }
}

function mapDispatchToProps(dispatch, ownProps: ListPackageProps): DispatchToProps {
    return {
        selectPackage: (pkg: IPackage, unseated: boolean, goDirectlyToSmartSeat: boolean = false) => {
            if (goDirectlyToSmartSeat) {
                window.location.href = `${window["pageData"].smartSeatUrl}?itemNumber=${pkg.id}`;
            } else {
                dispatch(selectPackage(pkg, false, unseated));
            }
            dispatch(toggleMiniCart(true));
        },
        removeFromCart: (itemId: number) => {
            dispatch(removeItemFromCart(itemId));
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListPackageBase);